import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { AuditPage } from './features/audit/pages/AuditPage.js';
import { LoginPage } from './features/auth/pages/LoginPage.js';
import { SetupTotpPage } from './features/auth/pages/SetupTotpPage.js';
import { ServerDetail } from './features/servers/pages/ServerDetail.js';
import { ServersDashboard } from './features/servers/pages/ServersDashboard.js';
import { SuperUsersPage } from './features/super-users/pages/SuperUsersPage.js';
import { AppShell } from './shared/components/layout/AppShell.js';
import { useAuthStore } from './stores/auth-store.js';

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

// Telas públicas (login / setup TOTP)
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
  beforeLoad: () => {
    const { user } = useAuthStore.getState();
    if (user) throw redirect({ to: '/' });
  },
});

const setupTotpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/setup-totp',
  component: SetupTotpPage,
});

// Layout autenticado (com AppShell)
const authLayout = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authLayout',
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
  beforeLoad: () => {
    const { user, bootstrapping } = useAuthStore.getState();
    if (bootstrapping) return; // ainda restaurando, deixa renderizar (App.tsx mostra spinner)
    if (!user) throw redirect({ to: '/login' });
  },
});

const dashboardRoute = createRoute({
  getParentRoute: () => authLayout,
  path: '/',
  component: ServersDashboard,
});

const serverDetailRoute = createRoute({
  getParentRoute: () => authLayout,
  path: '/servidores/$id',
  component: ServerDetail,
});

const superUsersRoute = createRoute({
  getParentRoute: () => authLayout,
  path: '/super-users',
  component: SuperUsersPage,
});

const auditRoute = createRoute({
  getParentRoute: () => authLayout,
  path: '/auditoria',
  component: AuditPage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  setupTotpRoute,
  authLayout.addChildren([dashboardRoute, serverDetailRoute, superUsersRoute, auditRoute]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
